import type { RefundRequestResponseRefundType } from './refundRequestResponseRefundType';
import type { RefundRequestResponseStatus } from './refundRequestResponseStatus';

export interface RefundRequestResponse {
  /** AI API 사용 횟수 */
  aiUsageCount?: number;
  /** 환불 가능 여부 */
  canRefund?: boolean;
  /** 환불 신청 일시 */
  createdAt?: string;
  /** 환불 처리 메시지 */
  message?: string;
  /** 주문 ID */
  orderId?: string;
  /** 원래 결제 금액 */
  originalAmount?: number;
  /** 환불 처리 일시 */
  processedAt?: string;
  /** 환불 사유 */
  reason?: string;
  /** 실제 환불 금액 */
  refundAmount?: number;
  /** 환불 신청 ID */
  refundRequestId?: string;
  /** 환불 유형 */
  refundType?: RefundRequestResponseRefundType;
  /** 환불 신청 상태 */
  status?: RefundRequestResponseStatus;
  /** 구독 사용 일수 */
  subscriptionDaysUsed?: number;
}
